import doFmRequest from './fmApiRequestor';

export const fetchFmDataProducts = async (idToken, isEnabled) => {
    const query = isEnabled !== undefined ? `?IsEnabled=${isEnabled}` : '';
    return doFmRequest(`/api/fm/dataproducts${query}`, idToken);
};

export const fetchFmApiHubAccess = async (idToken) => {
    return doFmRequest('/api/fm/apihub/access', idToken);
};

export const fetchFmExistingUsers = async (idToken) => {
    return doFmRequest('/api/fm/existingusers', idToken);
};

export const createFmExistingUser = async (idToken, existingUser) => {
    return doFmRequest('/api/fm/existingusers', idToken, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(existingUser)
    });
};

export const setFmExistingUserActive = async (idToken, id, isActive) => {
    return doFmRequest(`/api/fm/existingusers/${id}/active`, idToken, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ isActive })
    });
};

export const deleteFmExistingUser = async (idToken, id) => {
    return doFmRequest(`/api/fm/existingusers/${id}`, idToken, {
        method: 'DELETE'
    });
};

export const fetchFmDataProduct = async (idToken, id) => {
    return doFmRequest(`/api/fm/dataproducts/${id}`, idToken);
};

export const saveFmDataProduct = async (idToken, dataProduct) => {
    if (dataProduct.isNew) {
        return doFmRequest('/api/fm/dataproducts', idToken, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataProduct)
        });
    } else {
        return doFmRequest(`/api/fm/dataproducts/${dataProduct.id}`, idToken, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataProduct)
        });
    }
};

export const deleteFmPermissionRule = async (idToken, ruleId) => {
    return doFmRequest(`/api/fm/permissionrules/${ruleId}`, idToken, {
        method: 'DELETE'
    });
};

export const fetchFmAvailableDates = async (idToken, productId) => {
    return doFmRequest(`/api/fm/availableDates/${productId}`, idToken);
};

export const fetchFmInceptionDate = async (idToken, productAlias) => {
    return doFmRequest(`/api/fm/inceptiondate/${encodeURIComponent(productAlias)}`, idToken);
};

export const fetchFmData = async (idToken, productAlias, queryParams) => {
    let url = `/api/fm/data/${encodeURIComponent(productAlias)}`;
    if (queryParams) {
        const params = new URLSearchParams(queryParams).toString();
        if (params) url += `?${params}`;
    }
    return doFmRequest(url, idToken);
};

export const fetchFmDataProductAttributes = async (idToken, productId) => {
    return doFmRequest(`/api/fm/dataproductsattributes/${productId}`, idToken);
};

export const refreshFmDataProductDates = async (idToken, productAlias) => {
    return doFmRequest(`/api/fm/refreshdataproductsfiledates/${encodeURIComponent(productAlias)}`, idToken);
};
